import React, { useRef, useState, useEffect } from "react";
import {
  Form,
  Select,
  Upload,
  Input,
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  notification,
  Typography,
} from "antd";
import {
  HomeOutlined,
  InboxOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import image from "../../assets/contact.svg";
import { useSelector } from "react-redux";
import { decodeToken } from "react-jwt";
import UserAPI from "../../restAPI/UserAPI";
import contactAPI from "../../restAPI/ContactUsAPI";

const { Option } = Select;
const { Dragger } = Upload;
const { Title, Text } = Typography;

const ContactPage = () => {
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);
  const [attachments, setAttachment] = useState([]);
  const [userEmail, setUserEmail] = useState("");

  const [payload, setPayload] = useState({
    subject: "",
    message: "",
  });
  const [uploadListVisible, setUploadListVisible] = useState(true);
  const [errors, setErrors] = useState({});
  const [api,contextHolder] = notification.useNotification();
  const messageRef = useRef(null);
  const subjectRef = useRef(null);
  const formRef = useRef(null);
  const notificationShown = useRef(false);

  const openNotificationWithIcon = (type, message, description, placement) => {
    if (!notificationShown.current) {
      notification[type]({
        message: message,
        description: description,
        placement,
      });
      notificationShown.current = true;
      setTimeout(() => {
        notificationShown.current = false;
      }, 5000);
    }
  };
  const home = () => {
    navigate('/dashboard');
  };
  useEffect(() => {
    //decode token
    if (token !== null) {
      const decodedTokenValue = decodeToken(token);
      getUserById(decodedTokenValue.userId);
    }
  }, [token]);

  const getUserById = async (id) => {
    await UserAPI.getUserById(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId"),
      id
    )
      .then((res) => {
        if (res?.data) {
          let status = 1;
          if (res.data.status) {
            status = 1;
          } else {
            status = 0;
          }
          setUserEmail(res.data.email);
        }
      })
      .catch((err) => {
        console.log("error getting user data :", err.message);
      });
  };

  const validateFile = (file) => {
    const isValidType = [
      "application/pdf", 
      "image/jpeg", 
      "image/png",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ].includes(file.type);
    const isFileSizeValid = file.size / 1024 / 1024 < 10;

    if (!isValidType) {
      setErrors({
        attachments: `${file.name} is not a valid file type. Only PDF, JPEG, PNG, and Excel files are allowed.`,
      });
      return false; // Deny the file
    }

    if (!isFileSizeValid) {
      setErrors({
        attachments: `${file.name} is larger than 10MB. Please upload a smaller file.`,
      });
      return false; // Deny the file
    }

    setErrors({});
    return true; // Allow the file
  };

  const clearFields = () => {
    console.log(formRef.current);
    formRef.current.resetFields(["attachments"]);

    formRef.current.setFieldsValue({
      subject: "",
      message: "",
    });

  };

  const props = {
    name: "file",
    multiple: true,
    fileList: attachments, // Control the file list directly
    showUploadList: {
      showRemoveIcon: true,
      showPreviewIcon: false,
      showDownloadIcon: false,
      removeIcon: <ArrowLeftOutlined style={{ color: '#ff4d4f' }} />,
      renderItem: (originNode, file) => {
        const sizeInMB = (file.size / 1024 / 1024).toFixed(2);
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {originNode}
            <span style={{ marginLeft: 8, color: "#888" }}>
              {sizeInMB} MB
            </span>
          </div>
        );
      },
    },
    accept: ".pdf,.jpeg,.png,.xls,.xlsx",
    onRemove: (file) => {
      setAttachment((prevList) => {
        return prevList.filter((item) => {
          // Keep items that don't match the file to be removed
          // Match by uid first, then by name and size as fallback
          const matchesByUid = item.uid === file.uid;
          const matchesByNameAndSize = item.name === file.name && item.size === file.size;
          return !matchesByUid && !matchesByNameAndSize;
        });
      });
      // Clear any file limit errors when removing files
      setErrors({});
    },
    beforeUpload: (file) => {
      const isValid = validateFile(file);
      if (isValid) {
        setAttachment((prevList) => [...prevList, file]);
        return false; // prevent auto upload
      }
      return Upload.LIST_IGNORE;
    },
  };
  

  const handleFinish = async () => {

    if(localStorage.getItem("groupId") != null || localStorage.getItem("groupId") !== undefined)
    {
      // Debug log to track file count
      console.log("Current attachments count:", attachments.length);
      console.log("Attachments:", attachments.map(f => f.name));

      // Check if more than 5 files are uploaded
      if (attachments.length > 5) {
        openNotificationWithIcon(
          "error",
          "Too Many Files",
          `You have uploaded ${attachments.length} files. Maximum 5 files allowed for email. Please remove ${attachments.length - 5} file${attachments.length - 5 > 1 ? 's' : ''} before sending.`,
          "bottomLeft"
        );
        return;
      }

      const formData = new FormData();

      formData.append("message", payload.message);
      formData.append("subject", payload.subject);
      formData.append("userEmail", userEmail);
      formData.append("supportEmail", "customer_service@getmogu.co"); // Add supportEmail field
      if(attachments.length >0)
      {
      attachments.forEach((file, index) => {
        formData.append(`attachments`, file);
      });
      }

      await contactAPI
        .sendEmail(
          token,
          localStorage.getItem("groupId"),
          localStorage.getItem("companyId"),
          formData
        )
        .then((response) => {
          console.log("email response", response);
          setAttachment([]);
          clearFields();
          setUploadListVisible(false);
          setPayload({
            subject: "",
            message: "",
          });
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.message}`,
            "bottomLeft"
          );
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Send Email failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            openNotificationWithIcon(
              "error",
              "Send Email failed",
              `${err.message}`,
              "bottomLeft"
            );
          }
        });
      }
      else{
        openNotificationWithIcon(
          "error",
          "Send Email failed",
          "Please select a Group.",
          "bottomLeft"
        );
      }
  };

  const handleFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //message.error("Please check the form for errors and try again.");
  };

  return (
    <div>
      <Row>
        {contextHolder}
        <Col md={24}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item href="/">
              <HomeOutlined />
            </Breadcrumb.Item>

            <Breadcrumb.Item>Contact Us</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div className="border-container">
        <Button
          type="primary"
          variant="dashed"
          className="card-button"
          size="large"
          icon={<HomeOutlined />}
          onClick={home}
          shape="circle"
        />
        <Card title="Contact Us" bordered={true}>
          {/* Contact Information */}
          <Row gutter={24}>
            <Col xs={24} md={8}>
              <Row gutter={14}>
                <Col md={4}></Col>
                <Col md={16}>
                  <Title level={4}>Contact Information</Title>
                  <Row align="middle" style={{ marginBottom: 16 }}>
                    <MailOutlined
                      style={{ fontSize: "1.5em", color: "#1890ff" }}
                    />
                    <div style={{ marginLeft: 16 }}>
                      <Text strong>Email:</Text>
                      <br />
                      <a href="mailto:customer_service@getmogu.co">
                        customer_service@getmogu.co
                      </a>
                    </div>
                  </Row>
                  <Row align="middle" style={{ marginBottom: 16 }}>
                    <PhoneOutlined
                      style={{ fontSize: "1.5em", color: "#1890ff" }}
                    />
                    <div style={{ marginLeft: 16 }}>
                      <Text strong>Phone:</Text>
                      <br />
                      <a href="tel:+601123094643">+60 11-2309 4643</a>
                    </div>
                  </Row>
                  <Row align="middle">
                    <EnvironmentOutlined
                      style={{ fontSize: "1.5em", color: "#1890ff" }}
                    />
                    <div style={{ marginLeft: 16 }}>
                      <Text strong>Location:</Text>
                      <br />
                      Unit 21-12, Q Sentral, 2A, Jalan Stesen Sentral 2, Kuala Lumpur Sentral, 50470 Kuala Lumpur
                    </div>
                  </Row>
                </Col>
              </Row>
              <center>
                <img src={image} className="contact-image" />
              </center>
            </Col>

            {/* Contact Form */}
            <Col xs={24} md={16}>
              <Row gutter={14}>
                <Col md={4}></Col>
                <Col md={16}>
                  <Form
                    layout="vertical"
                    onFinish={handleFinish}
                    onFinishFailed={handleFinishFailed}
                    ref={formRef}
                  >
                    <Form.Item
                      label="Your Email"
                      required
                    >
                      <Input
                        name="yourEmail"
                        value={userEmail}
                        size="large"
                        placeholder="Enter your email"
                        disabled
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                      />
                    </Form.Item>
                    <Form.Item
                      label="Support Email"
                      name="supportEmail"
                      initialValue="customer_service@getmogu.co"
                    >
                      <Input 
                        size="large" 
                        disabled 
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Choose a Subject"
                      name="subject"
                      required
                      rules={[
                        { required: true, message: "Please select a subject!" },
                      ]}
                    >
                      <Select
                        size="large"
                        onChange={(value) => {
                          setPayload((prev) => ({
                            ...prev,
                            subject: value,
                          }));
                        }}
                        ref={subjectRef}
                        placeholder="Select a subject"
                      >
                        <Option value="general">General Inquiry</Option>
                        <Option value="technical">Technical Support</Option>
                        <Option value="billing">Billing</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Your Message"
                      name="message"
                      required
                      rules={[
                        {
                          required: true,
                          message: "Please enter your message!",
                        },
                        {
                          max: 500,
                          message:
                            "Your Messege must be less than 500 characters",
                        },
                      ]}
                    >
                      <Input.TextArea
                        rows={6}
                        ref={messageRef}
                        //value={payload["message"]}
                        placeholder="Enter your message"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        onChange={(e) => {
                          setPayload((prev) => ({
                            ...prev,
                            message: e.target.value,
                          }));
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Attachments"
                      name="attachments"
                      validateStatus={errors.attachments ? "error" : ""}
                      help={errors.attachments || ""}
                    >
                      <Dragger
                        name="files"
                        multiple
                        {...props}
                        listType="picture"
                        style={{
                          opacity: attachments.length >= 5 ? 0.6 : 1
                        }}
                      >
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">
                          Click or drag PDF, JPEG, PNG, Excel files to this area to upload
                        </p>
                        <p className="ant-upload-hint">
                          Maximum <strong>5 files</strong> can be sent via email, each up to <strong>10 MB</strong>
                          {attachments.length > 0 && (
                            <span style={{ 
                              color: attachments.length > 5 ? '#ff4d4f' : attachments.length === 5 ? '#faad14' : '#52c41a', 
                              marginLeft: 8 
                            }}>
                              ({attachments.length} file{attachments.length > 1 ? 's' : ''} uploaded)
                              {attachments.length > 5 && (
                                <span style={{ display: 'block', fontSize: '11px', marginTop: '2px' }}>
                                  Remove {attachments.length - 5} file{attachments.length - 5 > 1 ? 's' : ''} to send email
                                </span>
                              )}
                            </span>
                          )}
                        </p>
                      </Dragger>
                    </Form.Item>

                    <Form.Item>
                    <Button
                        size="large"
                        type="primary"
                        htmlType="submit"
                        block
                        disabled={attachments.length > 5}
                      >
                        Send Message
                      </Button>
                      {attachments.length > 5 && (
                        <div style={{ 
                          textAlign: 'center', 
                          marginTop: 8, 
                          color: '#ff4d4f',
                          fontSize: '12px'
                        }}>
                        You have {attachments.length} files. Only 5 files can be sent via email. Remove {attachments.length - 5} file{attachments.length - 5 > 1 ? 's' : ''} to send successfully.
                        </div>
                      )}
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default ContactPage;
